module.exports = __webpack_public_path__ + "static/img/mamanvogue-04.51b44d2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mamanvogue-04.webp
// module id = 115
// module chunks = 0